import { render, staticRenderFns } from "./reviews-slider.vue?vue&type=template&id=576ed00c&scoped=true&"
import script from "./reviews-slider.vue?vue&type=script&lang=js&"
export * from "./reviews-slider.vue?vue&type=script&lang=js&"
import style0 from "./reviews-slider.vue?vue&type=style&index=0&id=576ed00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ed00c",
  null
  
)

export default component.exports